import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AdminDashboardStats {
  totalUsers: number;
  totalProfessionals: number;
  totalPatients: number;
  activeSubscriptions: number;
  trialSubscriptions: number;
  expiredSubscriptions: number;
  pendingPayments: number;
  monthlyRevenue: number;
  totalRevenue: number;
}

export enum SubscriptionStatus {
  Trial = 1,
  Active = 2,
  PastDue = 3,
  Suspended = 4,
  Cancelled = 5,
  Expired = 6
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private readonly API_URL = `${environment.apiUrl}/admin`;

  constructor(private readonly http: HttpClient) {}

  // Dashboard
  getDashboardStats(): Observable<AdminDashboardStats> {
    return this.http.get<AdminDashboardStats>(`${this.API_URL}/dashboard`);
  }

  // Usuários
  getAllUsers(): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/users`);
  }

  getUserDetails(userId: number): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/users/${userId}`);
  }

  toggleUserStatus(userId: number, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/users/${userId}/toggle-status`, { isActive });
  }

  deleteUser(userId: number): Observable<any> {
    return this.http.delete(`${this.API_URL}/users/${userId}`);
  }

  // Profissionais
  getAllProfessionals(): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/professionals`);
  }

  toggleProfessionalStatus(professionalId: number, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/professionals/${professionalId}/toggle-status`, { isActive });
  }

  // Assinaturas
  getAllSubscriptions(status?: SubscriptionStatus): Observable<any> {
    let params = new HttpParams();
    if (status) params = params.set('status', status.toString());
    return this.http.get<any>(`${this.API_URL}/subscriptions`, { params });
  }

  cancelSubscription(subscriptionId: number, reason: string): Observable<any> {
    return this.http.put(`${this.API_URL}/subscriptions/${subscriptionId}/cancel`, { reason });
  }

  activateSubscription(subscriptionId: number): Observable<any> {
    return this.http.put(`${this.API_URL}/subscriptions/${subscriptionId}/activate`, {});
  }

  // Pagamentos
  getPendingPayments(page = 1, pageSize = 50): Observable<any> {
    const params = new HttpParams().set('page', page).set('pageSize', pageSize);
    return this.http.get<any>(`${this.API_URL}/payments/pending`, { params });
  }

  confirmPayment(paymentId: number): Observable<any> {
    return this.http.put(`${this.API_URL}/payments/${paymentId}/confirm`, {});
  }
}
